import { I18n } from '@calendly/i18n'
import { useMemo } from 'react'

import { filterEventTypes, setEditPermissions } from '../utils'

export const useLinkedAvailabilityEventTypes = (profilesWithEventTypes, ruleId, ownerName, managerCount, openedET) => useMemo(() => {
  if (!profilesWithEventTypes) return []

  const linked = filterEventTypes(
    profilesWithEventTypes,
    ({ userAvailabilityRuleId: availRuleId, id }) => {
      if (openedET && id === openedET.id) { return false }

      return availRuleId === ruleId
    }
  )

  const withoutOverride = filterEventTypes(
    linked,
    ({ availabilityOverride: override }) => !override
  )

  return setEditPermissions(withoutOverride, ownerName, managerCount)
}, [profilesWithEventTypes, ownerName, managerCount, openedET, ruleId])

export const useNonLinkedEventTypes = (profilesWithEventTypes, ruleId, ownerName, managerCount, openedET) => useMemo(() => {
  if (!profilesWithEventTypes) return []

  const customName = I18n.t('publisher.event_types.availability.schedules.custom')

  const nonLinked = filterEventTypes(
    profilesWithEventTypes,
    ({
      availabilityOverride: override,
      userAvailabilityRuleId: availRuleId,
      id
    }) => {
      if (openedET && id === openedET.id) { return false }

      return override || availRuleId !== ruleId
    }
  )

  const getRule = (activeRuleId) => profilesWithEventTypes.find(({ id, uuid }) => uuid === activeRuleId || id === activeRuleId)

  const withRuleNames = nonLinked.map((profile) => ({
    ...profile,
    eventTypes: profile.eventTypes.map(({ userAvailabilityRuleId: activeRuleId, ...item }) => ({
      ...item,
      ruleName: activeRuleId === null ? customName : getRule(activeRuleId)?.name
    }))
  }))

  return setEditPermissions(withRuleNames, ownerName, managerCount)
}, [profilesWithEventTypes, ownerName, managerCount, openedET, ruleId])
